import request from './request'

export const getRunnerReferrerRunnerList = (params) => {
  return request({
    url: '/admin/runner-referrer-runner',
    method: 'get',
    params
  })
}

export const getRunnerReferrerRunnerDetail = (id) => {
  return request({
    url: `/admin/runner-referrer-runner/${id}`,
    method: 'get'
  })
}

export const createRunnerReferrerRunner = (data) => {
  return request({
    url: '/admin/runner-referrer-runner',
    method: 'post',
    data
  })
}

export const updateRunnerReferrerRunner = (id, data) => {
  return request({
    url: `/admin/runner-referrer-runner/${id}`,
    method: 'put',
    data
  })
}

export const deleteRunnerReferrerRunner = (id) => {
  return request({
    url: `/admin/runner-referrer-runner/${id}`,
    method: 'delete'
  })
}
